import ActionReporterService from '../entrypoints/src/admin/services/action-reporter-service';

import { Controller } from "stimulus";

export default class extends Controller {
  static values = {
    reportableId: Number,
    action: String,
    subAction: String,
  }

  connect() {
    console.log('attendance meet controller');
    this.element.addEventListener('jitsi:start', (ev) => this.onNewMeeting(ev.api));
    this.element.addEventListener('jitsi:end', (ev) => this.endMeeting());
  }

  async onNewMeeting(api) {
    this.actionReport = await ActionReporterService.reportAction('attendances', this.reportableIdValue, this.actionValue, this.subActionValue);
  }

  async endMeeting() {
    await ActionReporterService.endAction('attendances', this.reportableIdValue, this.actionReport.id);
  }
}
